import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { T } from "utils/backrrTokens";

// Every number on this page is a definition as much as a value — "match rate"
// and "subscription purchase rate" each have four plausible denominators, and an
// admin reading the wrong one draws the wrong conclusion. The definition lives
// here rather than in the subtitle so the page keeps its density.
//
// A real <button>, not an icon on a div: the tooltip has to open on keyboard
// focus too, and `describedby` is how a screen reader reaches the text at all.
const InfoHint = ({ text, label }) => (
  <Tooltip
    title={text}
    enterTouchDelay={0}
    leaveTouchDelay={6000}
    describeChild
    componentsProps={{
      tooltip: {
        sx: {
          fontSize: "0.72rem",
          fontWeight: 400,
          lineHeight: 1.45,
          padding: "8px 10px",
          maxWidth: 260,
          backgroundColor: T.ink,
        },
      },
    }}
  >
    <IconButton
      size="small"
      aria-label={label ? `About ${label}` : "More information"}
      sx={{
        padding: "2px",
        marginLeft: "2px",
        position: "relative",
        color: T.inkSubtle,
        "&:hover": { color: T.accent, backgroundColor: "transparent" },
        "&:focus-visible": { outline: `2px solid ${T.accent}`, outlineOffset: "1px" },
        // The icon stays 17px because a 44px glyph would shout on a dense
        // dashboard — but a 17px TARGET is unusable with a thumb. The hit area
        // is grown to ~45px with an absolutely positioned overlay, so it costs
        // the layout nothing and the visual weight is unchanged.
        "&::after": {
          content: '""',
          position: "absolute",
          inset: "-14px",
          borderRadius: "50%",
        },
      }}
    >
      <InfoOutlined sx={{ fontSize: "0.85rem" }} />
    </IconButton>
  </Tooltip>
);

export default InfoHint;
